<template>
  <v-select :options="accessibleUnits"
    :placeholder="this.$route.name != 'licensesPending' && this.$route.name != 'supportPending' ? $t('members-table.selectAUnit') : $t('licenses.allUnits')"
    :disabled="disableSelect" v-model="displayUnit" @input="atInput">
    <template #no-options="{}">
      {{ $t("members-table.noOptions") }}
    </template>
  </v-select>
</template>

<script>
import {getSelectedUnitId} from "esep/src/services/utils";

export default {
  computed: {
    accessibleUnits: function () {
      let units = [];
      for (let i = 0; i < this.$store.state.usersAccessibleUnits.length; i++) {
        const orgUnitName = this.$store.state.usersAccessibleUnits[i].name;
        const orgUnitId = this.$store.state.usersAccessibleUnits[i].id;
        const orgUnitType = this.$store.state.usersAccessibleUnits[i].type;
        const unit = { label: orgUnitName, id: orgUnitId, type: orgUnitType };
        units.push(unit);
      }
      return units;
    }
  },
  mounted() {
    let displayUnitId;
    this.$log.debug(this.$store.state.userInfo.orgMember);
    if (this.selectedUnitId != null) {
      displayUnitId = this.selectedUnitId;
    } else {
      if (this.$route.name != 'licensesPending' && this.$route.name != 'supportPending') {
        getSelectedUnitId(this.$store);
      } else {
        displayUnitId = null;
      }

    }

    this.displayUnit = this.accessibleUnits.find((unit) => unit.id == displayUnitId);
    this.$store.state.selectedUnit = this.displayUnit;

    if (this.$route.name != 'licensesActive' && this.$route.name != 'licensesAdd' && this.$route.name != 'licensesPending' && this.$route.name != 'supportActive' && this.$route.name != 'supportAdd') {
      this.atInput();
    }

  },
  props: {
    selectedUnitId: {
      type: Number
    },
    disableSelect: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      displayUnit: null
    }
  },
  methods: {
    atInput() {
      this.$emit('input-change', this.displayUnit);
    }
  }
}
</script>
